<!--
产康的团购页面
-->
<template>
  <div class="recovery-layout" ref="container">
    <div class="group-content" v-show="Object.keys(groupInfo).length > 0">
      <div ref="productId">
        <banner :product="product" :showPrice="false"></banner>
      </div>
      <div class="group-detail">
        <div class="info-box">
          <div class="price">
            <div class="cur-price">
              &yen;
              <span class="cur-price-group">{{
                groupInfo.groupPrice / 100
              }}</span>
              <span class="group-scale number500"
                >{{ groupInfo.groupLimitNum }}人团</span
              >
            </div>
            <div class="other-message">
              <p class="pre-price">
                单买价&nbsp;&yen;<span>{{ groupInfo.presentPrice / 100 }}</span>
              </p>
            </div>
          </div>
          <div
            class="count-down"
            v-if="groupState === 1 && groupInfo.saleNum > 0"
          >
            已拼{{ groupInfo.saleNum }}份
          </div>
        </div>
      </div>
      <div class="group-info">
        <div class="group-desc">
          <div class="title-warper">
            <h3 class="group-name pf-medium">
              <span v-if="product.selfPurchase" class="self">{{
                product.selfPurchaseName
              }}</span>
              {{ groupInfo.skuName }}
            </h3>
            <ShareButton
              v-if="showShare"
              class="share"
              :promotion-info="sharePromotion"
            >
              <div class="share_btn">
                <img
                  src="data:image/png;base64,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"
                />
                <span>分享</span>
              </div>
            </ShareButton>
          </div>
          <!-- <div class='service-info'>
                        <span>{{groupInfo.groupName}}</span>
                        <span class='company'><i class="shop-icon"></i>{{product.businessName}}</span>
                    </div> -->
          <labels :product="product"></labels>
          <actionSheet :viewName="viewName"></actionSheet>
        </div>
        <div class="tip-layout" v-if="$store.state.tip">
          <tip></tip>
        </div>
        <otherGroups
          v-if="otherGroupsList.length > 0"
          :otherGroups="otherGroupsList"
          :jumpOrderConfirm="jumpOrderConfirm"
          :watchMore="watchMore"
          :spuId="Number(spuId)"
          :skuId="Number(skuId)"
          :serviceTime="groupInfo.serviceTime"
        ></otherGroups>
        <div class="group-rule">
          <span class="number500">拼团规则</span
          ><span>开团/参团 - 邀请好友 - 拼团成功 (不满自动退)</span>
        </div>

        <div class="store-info-layout">
          <storeInfo :product="product"></storeInfo>
        </div>

        <nav-tab
          ref="navTab"
          :scrollIndex.sync="scrollIndex"
          @change="changeTab"
          @scroll="handleScroll"
        />
        <productIntro :product="product" ref="introduceId" class="mg-bottom" />
        <BuyNotice :product="product" ref="noticeId" />
        <div class="productComment" ref="commentId" v-show="commentCount > 0">
          <comment
            id="commentId"
            :comments="comments"
            :count="commentCount"
            :spuId="spuId"
          ></comment>
        </div>

        <otherServiceProduct
          v-if="otherServiceDatas.length > 0"
          :products="otherServiceDatas"
          ref="productId"
        />

        <!-- 锚点高度不足用 -->
        <div ref="bottom"></div>
      </div>
      <div class="confirm-buttons" :class="{ 'adapt-iponeX': judgeIponex }">
        <btnTel
          slot="icons"
          v-if="product.businessPhone"
          @tel="tel(product.businessPhone)"
        ></btnTel>
        <div class="btn-all">
          <button class="direct-reservation" @click="purchase(false)">
            <span>&yen;{{ groupInfo.presentPrice / 100 }}</span>
            <p>直接购买</p>
          </button>
          <button @click="purchase(true)" v-if="groupState === 1">
            <span>&yen;{{ groupInfo.groupPrice / 100 }}</span>
            <p>{{ buttonText }}</p>
          </button>
          <button class="invalid" v-else>{{ buttonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from '@/components/home/banner'
// import storeInfo from "@/components/home/recovery/storeInfo";
import storeInfo from '../home/components/store'

import serveDetail from '@/components/home/detail'
import labels from '@/components/groupBuy/recovery/labels'
import actionSheet from '@/components/actionSheet'
import tip from '@/components/home/recovery/tip'
import otherGroups from '@/components/groupBuy/otherGroups'
import countDown from '@/components/common/countDown'
import btnTel from '@/components/common/btnTel'

import navTab from '@/router/home/components/common/nav-tab'
import productIntro from '@/router/home/components/product/product-intro/index'
import BuyNotice from '@/router/home/components/product/product-intro/buy-notice.vue'
import otherServiceProduct from '@/router/home/components/product/other-product'
import mixTab from '@/mixin/mixTab'

import comment from '@/components/home/comment'
import utils from '@/plugins/utils'
import Cookie from 'js-cookie'
import { mapState } from 'vuex'
import isIOS from '@/plugins/isIOS'
import ShareButton from '@/components/share/ShareButton.vue'

export default {
  mixins: [mixTab],
  PAGE_ID: '121012367',
  data() {
    return {
      showShare: false,
      targetTime: 0,
      timeOffset: 0,
      groupState: 1,
      spuId: 0,
      skuId: 0,
      ruleType: 4,
      ruleId: '',
      groupId: '',
      leftNumber: 0,
      isInvited: 0,
      isIOS: true,
      businessId: '' //商家id
    }
  },
  watch: {
    viewName(val, oldVal) {
      if (val !== oldVal && this.$store.state.needArrow) {
        this.$store.commit('setArrowState', false)
      }
    }
  },
  async created() {
    //this.$$title('拼团详情')
    // 获取商品详情的内容
    try {
      //这边人客也显示 普通商详没显示 是因为普通商详有分享按钮 而拼团没做
      this.showShare = utils.isHzwApp() || utils.isRkhy() || this.isMinProgram
      await this.fetchGroupDetail()
      this.businessId = this.product.businessId
      //this.confirmShareInfo()
      this.isIOS = isIOS
      //this.getOtherServices()
      //this.getComments()
    } catch (e) {}
  },

  components: {
    banner,
    countDown,
    serveDetail,
    labels,
    storeInfo,
    actionSheet,
    tip,
    otherGroups,
    otherServiceProduct,
    btnTel,
    productIntro,
    navTab,
    comment,
    BuyNotice,
    ShareButton
  },
  computed: {
    buttonText() {
      const textObj = { 0: '已失效', 2: '已失效', 3: '已抢完' }
      if (this.groupState === 1) {
        if (this.groupInfo.groupType === 1) {
          return '参团'
        } else {
          return this.isInvited === 1 ? '立即参与好友团' : '拼团购买'
        }
      } else {
        return textObj[this.groupState]
      }
    },
    sharePromotion() {
      if (this.groupInfo) {
        const tag =
          +this.groupInfo.groupLimitNum === 1
            ? '拼团'
            : `${this.groupInfo.groupLimitNum}人团`
        return {
          price: this.groupInfo.groupPrice,
          tag,
          title: this.groupInfo.skuName,
          contentType: 202
        }
      }
      return {}
    },
    judgeIponex() {
      // const isIOS = /iPhone|iPad/i.test(navigator.userAgent)
      return isIOS && window.screen.height >= 812
    },
    ...mapState([
      'product',
      'groupInfo',
      'otherGroupsList',
      'viewName',
      'comments',
      'commentCount',
      'isMinProgram',
      'otherServiceDatas'
    ])
  },
  methods: {
    async fetchGroupDetail() {
      const vueQuery = this.$route.query || {}
      this.spuId = this.$route.params.spuId || ''
      this.skuId = vueQuery.skuId || ''
      this.ruleId = vueQuery.ruleId || ''
      this.groupId = vueQuery.groupId || ''
      this.isInvited = vueQuery.isInvited * 1
      // const query = this.$$queryString.stringify({
      //     spuId: this.spuId,
      //     skuId: this.skuId || '',
      //     ruleType: 4,
      //     ruleId: this.ruleId || '',
      //     uid: this.$$cookie('uid') || '',
      //     skey: this.$$cookie('uid') || '',
      //     appSource: this.$$getDevice(),
      // })
      // await this.$store.dispatch('getProductDetail', query)
      // // 如果没有groupDetail这个字段，跳正常商详
      // if (Object.keys(this.groupInfo).length < 1) {
      //     location.replace(`/v/product/${this.spuId}?refresh=no`)
      // }
      // await this.$store.dispatch('getMainConfig')
      // ios处理不了字符串日期的'-',要转换成'/'
      // eslint-disable-next-line no-useless-escape
      this.targetTime = new Date(
        this.groupInfo.endTime.replace(/\-/g, '/')
      ).getTime()
      this.timeOffset = this.groupInfo.serviceTime - Date.now()
      if (!this.groupInfo.serviceTime) {
        this.timeOffset = 0
      }
      this.groupState = this.groupInfo.state * 1
    },
    // 购买按钮，开团或者参团
    async purchase(groupMark) {
      // eslint-disable-next-line prefer-const
      let { spuId, skuId, groupRuleId } = this.groupInfo
      // 因为其余拼团列表返回的信息中没有spu和sku，所以从父组件传给他，不然没有办法跳到订单确认页
      if (!spuId || !skuId) {
        spuId = this.spuId
        skuId = this.skuId
      }

      const skuid = skuId
      const popid = this.product && this.product.businessId

      this.newTrackClick(
        200020,
        undefined,
        `skuid: ${skuid || ''}, popid: ${popid || ''}`
      )

      let query
      if (groupMark) {
        query = {
          skuId,
          ruleId: groupRuleId,
          ruleType: 4,
          groupId: this.groupId
        }
      } else {
        query = {
          skuId,
          ruleType: 1
        }
      }

      await this.jumpOrderConfirm(spuId, query)
    },
    // getComments() {
    //     // 获取评价数据
    //     this.$store.dispatch('getComments', {
    //         page: 1,
    //         size: 2,
    //         spuId: this.spuId
    //     })
    // },
    // 跳转订单确认页
    async jumpOrderConfirm(spuId, query) {
      const queryStr = this.$$queryString.stringify(query)
      const info = this.fetchShareKey()
      const hserecomkey = info.hserecomkey
      const module = info.module
      const mmz = info.mmz || ''

      let url = `${this.$$hostname('life')}/v/product/${
        this.spuId
      }/confirm?${queryStr}&cmd=share&sharetype=0&refresh=no&module=${module}&mmz=${mmz}`
      await this.$$ensureLogin(url)

      this.$router.push({
        name: 'product-confirm',
        params: {
          spuId
        },
        query: {
          ...query,
          hserecomkey,
          cmd: 'share',
          sharetype: 0,
          refresh: 'no',
          module
        }
      })
      if (window.kwapp) {
        window.kwapp.allowRefreshOrShare(false, false)
      }
    },
    // 查看更多参团列表
    watchMore() {
      this.$router.push({
        name: 'more-groups',
        query: {
          skuId: this.skuId,
          spuId: this.spuId,
          ruleId: this.ruleId,
          module: this.$route.query.module || ''
        }
      })
    },
    // 确定分享信息
    // confirmShareInfo() {
    //     const { groupDesc: title, coverPic: imgUrl, groupName: desc } = this.groupInfo
    //     const shareInfo = {
    //         title,
    //         imgUrl,
    //         desc,
    //         link: location.href
    //     }
    //     window.getAppShareInfo = () => shareInfo
    // },
    // 获取分享key
    fetchShareKey() {
      const params = location.search.replace(/^\?/, '').split('&')
      let hserecomkey = ''
      let module = ''
      params.forEach(p => {
        const res = p.split('=')
        if (res[0] === 'hserecomkey') {
          hserecomkey = res[1]
        }
        if (res[0] === 'module') {
          module = res[1]
        }
        //fromDailySale=1 代表天天特卖频道模块
        if (res[0] === 'fromDailySale' && res[1] === '1') {
          module = '1'
        }
      })
      return {
        hserecomkey,
        module
      }
    },
    tel(tel) {
      let { skuId } = this.groupInfo
      if (!skuId) {
        skuId = this.skuId
      }

      const skuid = skuId
      const popid = this.product && this.product.businessId

      this.newTrackClick(
        200018,
        undefined,
        `skuid: ${skuid || ''}, popid: ${popid || ''}`
      )
      window.location.href = `tel:${tel}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.tabs-layout {
  height: rem(84px);
  margin-top: 0;
}
.store-info-layout {
}
header {
  overflow: hidden;
  width: 100%;
  position: fixed;
  z-index: 300;
  left: 0;
  top: 0;
  height: rem(84px);
  background: #fff;

  .tabbar {
    display: flex;
    height: 100%;

    justify-content: center;

    .tabbar-item {
      color: #666666;
      display: flex;
      justify-content: center;
      font-size: rem(28px);

      flex: 1;
      align-items: center;
    }
    .active {
      box-sizing: content-box;
      color: #ff397e;
      font-weight: bold;
      font-size: rem(34px);
      position: relative;
      &:after {
        display: block;
        content: '';
        position: absolute;
        height: rem(6px);
        background: #ff397e;
        width: rem(24px);
        border-radius: 3px;
        bottom: rem(8px);
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.group-content {
  padding-bottom: rem(120px);
}

.group-detail {
  width: 100%;
  height: rem(130px);
  background: url('~@/assets/images/product/tuan-bg@3x.png') 0 0 no-repeat;
  background-size: 100% auto;
  overflow: hidden;
  z-index: 99;
  padding: 0 rem(30px);
  .info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    height: 100%;
    color: #fff;

    .price {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .cur-price {
        font-size: rem(28px);
        margin-right: rem(4px);
        display: flex;
        align-items: flex-end;

        .cur-price-group {
          font-size: rem(48px);
          line-height: rem(44px);
          margin-right: rem(12px);
          margin-left: rem(4px);
        }
        .group-scale {
          padding: 0 rem(9px);
          font-size: rem(22px);
          color: #ff5900;
          line-height: rem(36px);
          height: rem(36px);
          background: #ffffff;
          border-radius: rem(18px);
          align-self: center;
        }
      }

      .other-message {
        .pre-price {
          margin-top: rem(8px);
          font-size: rem(22px);
          line-height: rem(30px);
        }
      }
    }

    .count-down {
      font-size: rem(26px);
      color: #ffffff;
    }
  }
}

.group-info {
  margin: 0;

  .group-desc {
    background: #fff;
    padding: 0 rem(30px);
    font-size: rem(26px);
    color: #666666;
    border-radius: rem(8px);
    margin-bottom: rem(20px);

    .title-warper {
      display: flex;
      align-items: center;
    }
    .share {
      margin-left: rem(20px);
      margin-right: rem(20px);
      .share_btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: rem(35px);
          height: rem(35px);
        }
        span {
          margin-top: rem(6px);
          color: #333;
          font-size: rem(24px);
        }
      }
    }
    .group-name {
      flex: 1;
      padding: rem(32px) 0;
      font-size: rem(36px);
      color: #121212;
      line-height: rem(42px);
      font-weight: bold;
    }
    .self {
      height: rem(32px);
      font-size: rem(22px);
      line-height: rem(32px);
      display: inline-block;
      color: white;
      padding: 0 rem(8px);
      vertical-align: top;
      margin-top: rem(4px);
      margin-right: rem(8px);
      border-radius: rem(14px);
      background: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    }

    .service-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 rem(20px);
      line-height: rem(32px);
      margin-bottom: rem(10px);

      .company {
        margin-top: rem(16px);
        color: #999;
        overflow: hidden;
        display: flex;
        align-items: center;

        .shop-icon {
          display: inline-block;
          margin-right: rem(10px);
          width: rem(24px);
          height: rem(24px);
          box-sizing: border-box;
          background: url('//cmspic-10004025.image.myqcloud.com/086d4a90-225b-11ea-a5e7-dbd8a7023663_size_36x36')
            no-repeat center center;
          background-size: contain;
          flex-shrink: 0;
        }
      }
    }
  }

  .group-rule {
    display: flex;
    background-color: #fff;
    padding: rem(35px) rem(30px);
    font-size: rem(26px);
    color: #262626;
    span:first-child {
      margin-right: rem(20px);
    }
  }
}

.serve-detail {
  margin: 0 rem(-20px) 0;
}

.confirm-buttons {
  width: rem(750px);
  padding-top: rem(10px);
  padding-bottom: rem(10px);
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  z-index: 100;
  .btn-all {
    display: flex;
    margin: 0 rem(30px);
    border-radius: rem(40px);
    overflow: hidden;
    button {
      width: rem(263px);
      height: rem(80px);
      font-size: rem(32px);
      line-height: rem(32px);
      text-align: center;
      color: #fff;
      span {
        font-size: rem(26px);
      }
      p {
        font-size: rem(22px);
      }

      &:first-child {
        background-color: #ffb637;
      }
      &:last-child {
        background-color: #ff5900;
      }
      &.invalid {
        background: #bbb;
      }
    }
  }
}

.confirm-buttons.adapt-iponeX {
  padding-bottom: rem(50px);
}
.tip-layout {
  padding: rem(20px) rem(30px);
  padding-bottom: 0;
  background-color: #fff;
  position: relative;
  margin-bottom: rem(20px);
  height: rem(70px);
  overflow: hidden;
}

.mg-bottom {
  margin-bottom: rem(20px);
}
</style>
